// extracted by mini-css-extract-plugin
export default {"container":"MobileProfileTabs_container__gf80S"};